/**
 * <bundles-explorer> — the Bundles page. A dropdown (image + name) picks the product; its list is
 * grouped by collection. Picking a product shows its panel of bundles and keeps the choice in the URL
 * (?product=<handle>) so it can be linked and survives Back.
 */
if (!customElements.get('bundles-explorer')) {
  class BundlesExplorer extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.bundles-explorer__toggle');
      this.list = this.querySelector('.bundles-explorer__list');
      this.options = [...this.querySelectorAll('.bundles-explorer__option')];
      this.panels = [...this.querySelectorAll('.bundles-explorer__panel')];
      if (!this.toggle || !this.list) return;

      this.toggle.addEventListener('click', () => this.setOpen(this.list.hidden));
      this.options.forEach((option) =>
        option.addEventListener('click', () => {
          this.select(option.dataset.product, true);
          this.setOpen(false);
          this.toggle.focus();
        })
      );
      this.list.addEventListener('keydown', (event) => this.onListKey(event));
      this.toggle.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.setOpen(true);
        }
      });
      document.addEventListener('click', (event) => {
        if (!this.list.hidden && !this.querySelector('.bundles-explorer__dropdown').contains(event.target)) this.setOpen(false);
      });

      const fromUrl = new URLSearchParams(window.location.search).get('product');
      if (fromUrl && this.options.some((o) => o.dataset.product === fromUrl)) this.select(fromUrl, false);
    }

    setOpen(open) {
      this.list.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      if (open) (this.options.find((o) => o.getAttribute('aria-selected') === 'true') || this.options[0])?.focus();
    }

    onListKey(event) {
      const index = this.options.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        this.setOpen(false);
        this.toggle.focus();
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const next = this.options[Math.max(0, Math.min(this.options.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))];
        next?.focus();
      }
    }

    select(handle, userAction) {
      const option = this.options.find((o) => o.dataset.product === handle);
      if (!option) return;
      this.options.forEach((o) => o.setAttribute('aria-selected', String(o === option)));
      this.panels.forEach((panel) => (panel.hidden = panel.dataset.product !== handle));
      this.querySelector('[data-current-name]').textContent = option.dataset.name;
      const image = option.querySelector('img');
      this.querySelector('[data-current-image]').innerHTML = image ? image.outerHTML.replace(' loading="lazy"', '') : '';
      if (!userAction) return;
      const url = new URL(window.location.href);
      url.searchParams.set('product', handle);
      window.history.replaceState({}, '', url);
    }
  }
  customElements.define('bundles-explorer', BundlesExplorer);
}
